import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './check-box.css';

export class CheckBoxSingle extends Component {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChecked: PropTypes.func,
    value: PropTypes.any,
    style: PropTypes.any,
    disabled: PropTypes.bool,
    disableClick: PropTypes.bool,
    labelStyle: PropTypes.object,
    indeterminate: PropTypes.bool,
    title: PropTypes.string
  }

  static defaultProps = {
    checked: false,
    disableClick: false
  }

  constructor(props) {
    super(props);

    this.id = uuidv4();

    const { name, value, checked } = this.props;

    this.state = {
      id: this.id,
      name: name,
      checked: checked,
      value: value
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked
    });
  }

  onSetValue = (value) => {
    this.setState({
      checked: value
    });
  }

  onToggleClick = (e) => {
    if (!this.props.disableClick) {
      this.setState({
        checked: !this.state.checked
      }, () => {
        this.props.onChecked(e, this.props.value, this.state);
      });
    }
  }

  render() {
    const {
      labelStyle,
      label,
      className,
      style,
      value,
      indeterminate,
      disabled,
      disableClick,
      title
    } = this.props;

    const { id, name, checked } = this.state;

    let styleOfLabel = labelStyle ? labelStyle : {};

    return <div itemID={id} className={`checkbox ${className}`} style={style}>
      <input
        id={id}
        name={name}
        className='s1-ckb'
        type='checkbox'
        value={value}
        checked={checked}
        ref={el => el && (el.indeterminate = indeterminate)}
        disabled={disabled}
        onChange={() => {}}
        disableclick={disableClick.toString()}
        onClick={this.onToggleClick}
        title={title}
      />
      <label htmlFor={id} style={disabled ? {opacity: '0.5', color: '#333333'} : styleOfLabel}> {label}</label>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/checkboxes/check-box-single.js